import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@infragistics/igniteui-dockmanager/loader';

// Locales
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeJa from '@angular/common/locales/ja';
registerLocaleData(localeJa);
registerLocaleData(localeFr);

import { environment } from '@Environment/environment';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';

/**
 * main.tsで呼ぶ必要有り、これを呼ばないとdockManager内にigx-radio（ラジオボタン）が有る場合にフリーズしてしまう
 * https://www.infragistics.com/products/ignite-ui-angular/angular/components/dock-manager#usage
 */
defineCustomElements();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
